import { lazy } from "react";

// Patient Map — Call Center: pantalla NUEVA de solo lectura para el call
// center (no reemplaza ni toca el Patient Map clínico). Acceso restringido a
// admin/CEO + call center agent + care coordinator vía roleRoutePermissions
// (allowlist "cca"/"care_coordinator").
// Guía: docs/modulos/PatientInfoV2/MODULO_01_PATIENT_MAP_CALL_CENTER_GUIA_FRONTEND.md

// Feature flag del proyecto: en false el módulo exporta [] y la ruta no se monta.
const PATIENT_MAP_CALL_CENTER_ENABLED = true;

const PatientMapCallCenterPage = lazy(() => import("./PatientMapCallCenterPage"));

export const patientMapCallCenterRoutes = PATIENT_MAP_CALL_CENTER_ENABLED
  ? [{ path: "/patient-map/call-center", element: <PatientMapCallCenterPage /> }]
  : [];
